import React from "react";

export default function Project({ img, name, information }) {
  return (
    <div className="project">
      <div className="img-project">
        <img src={img} alt="" />
      </div>
      <div className="details">
        <h1>{name}</h1>
        <p>{information}</p>
      </div>
    </div>
  );
}
